import { autocompleteComponent } from './autocomplete.component';
import typeahead from 'angular-ui-bootstrap/src/typeahead/index-nocss.js';
import {typeaheadFocusDirective} from './typeahead-focus.directive';
import each from 'lodash/each';
import filter from 'lodash/filter';
import './autocomplete.scss';

export const autocomplete = angular
	.module('common.components.autocomplete', [
		typeahead
	])
	.component('autocomplete', autocompleteComponent)
	.directive('typeaheadFocus', typeaheadFocusDirective)
	.filter('norepeat', function(){
		return function(items, tags, allowRepeat){
			var filterItems = [];
			if(allowRepeat){
				filterItems = items;
			}else{
				if(tags.length !== items.length){
					each(items,(item)=>{
						let filterObj = filter(tags, (tag) => { 
							return tag === item.name;
						});
						if(filterObj.length === 0){
							filterItems.push(item);
						}
					});
				}	
			}
			return filterItems;
		}
	})
	.filter('filterAutocompleteItems', () => {
		return (items, searchText) => {
			return _onChangeSearchText(items, searchText);
		};


		function _onChangeSearchText(items, searchText) {
			if (searchText && searchText !== ' ') {
				const regex = _getRegexForSearchText(searchText);
				return _getMatchResult(items, regex);
			} else {
				return items;
			}
		}

		function _getRegexForSearchText(searchText) {
			return new RegExp(`^${searchText}`,'i');
		}

		function _getMatchResult(items, regex) {
			return items.filter(({ name }) => regex.test(name));
		}
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/autocomplete/autocomplete.module.js